import { render } from "./SetupView.vue?vue&type=template&id=6a272a96&scoped=true&ts=true"
import script from "./SetupView.vue?vue&type=script&lang=ts"
export * from "./SetupView.vue?vue&type=script&lang=ts"

import "./SetupView.scss?vue&type=style&index=0&id=6a272a96&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a272a96"]])

export default __exports__